export default function GetInvolvedPage() {
  return (
    <h1>Get Invovled</h1>
  )
}
